/* eslint-disable no-extra-boolean-cast */
import React, { useContext } from "react";

import { Route } from "react-router-dom";

import { AuthContext } from "../contexts/Auth"
import AuthFlow from "../components/AuthFlow"

const PrivateRoute = ({ component: RouteComponent, authFlowLayout: Layout, ...rest }) => {
  const { emailVerified } = useContext(AuthContext)

  if (emailVerified) {
    // user is logged in, proceed normally, wrap as normal route as RouteComponent
    // may be depending on standard props passed to routes
    return (
      <Route
        {...rest}
        render={routeProps => ( <RouteComponent {...routeProps} /> ) }
      />
    )
  } else if (!!Layout) {
    // return AuthFlow embeded within provided layout
    return (
      <Layout {...rest} >
        <AuthFlow {...rest}/>
      </Layout>
    )
  } else {
    // simply return AuthFlow with out any wrapping layout
    return ( <AuthFlow {...rest}/> )
  }

  // if (!unauthedComponent) {
  //   unauthedComponent = (
  //     <>
  //     <AuthFlow />
  //     </>
  //   )
  // }

  // return (
  //   <Route
  //     {...rest}
  //     render={routeProps =>
  //       !!currentUser ? (
  //         <RouteComponent {...routeProps} />
  //       ) : (
  //         unauthedComponent
  //       )
  //     }
  //   />
  // );
}


export default PrivateRoute